import { Routes } from '@angular/router'
import { RouteEnum } from './models/route-enum'
import { ArticlePageComponent } from './pages/article/article-page.component'
import { ExtraPageComponent } from './pages/extra/extra-page.component'
import { HomePageComponent } from './pages/home/home-page.component'
import { SettingsPageComponent } from './pages/settings/settings-page.component'
import { introGuard } from './guards/intro.guard'
import { languageGuard } from './guards/language.guard'
import { IntroPageComponent } from './pages/intro/intro-page.component'
import { webOnlyGuard } from './guards/web-only.guard'

export const routes: Routes = [
  {
    path: 'intro',
    component: IntroPageComponent,
    data: { title: RouteEnum.Intro },
  },
  {
    path: 'download',
    canMatch: [webOnlyGuard],
    loadComponent: () =>
      import('./pages/mobile-promotion/mobile-promotion-page.component').then(
        (module) => module.MobilePromotionPageComponent,
      ),
    data: { title: RouteEnum.MobilePromotion },
  },
  {
    path: '',
    component: HomePageComponent,
    canActivate: [introGuard],
    data: { title: RouteEnum.Home },
  },
  {
    path: 'article/:slug',
    component: ArticlePageComponent,
    canActivate: [languageGuard, introGuard],
    data: { title: RouteEnum.Article },
  },
  {
    path: 'page/:slug',
    component: ExtraPageComponent,
    canActivate: [languageGuard, introGuard],
    data: { title: RouteEnum.Page },
  },
  {
    path: 'settings',
    component: SettingsPageComponent,
    canActivate: [introGuard],
    data: { title: RouteEnum.Settings },
  },
  { path: '**', redirectTo: '' },
]
